import TripGeneralInfosFormContainer from './TripGeneralInfosFormContainer';

export default TripGeneralInfosFormContainer;
